// src/Components/ui/LanguageSwitcher.js
import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Wrapper = styled.div`
  display: flex;
  gap: 0.35rem;
`;

const LangButton = styled.button`
  background-color: rgba(45, 91, 79, 0.08);
  border: 1px solid rgba(45, 91, 79, 0.2);
  color: #2d5b4f;
  min-width: 44px;
  min-height: 38px;
  border-radius: 999px;
  padding: 0.32rem 0.65rem;
  font-weight: 700;
  font-size: 0.9rem;
  cursor: pointer;
  font-family: "Fraunces", serif;
  letter-spacing: 0.02em;
  box-shadow: none;
  transition: all 0.2s ease;
  opacity: ${(props) => (props.$active ? 1 : 0.88)};

  ${(props) =>
    props.$active &&
    `
    background-color: #2d5b4f;
    border-color: #2d5b4f;
    color: #fff;
  `}

  &:hover {
    background-color: #2d5b4f;
    border-color: #2d5b4f;
    color: #fff;
    transform: translateY(-1px);
  }
`;

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <Wrapper>
      <LangButton
        type="button"
        $active={i18n.language?.startsWith("es")}
        onClick={() => changeLanguage("es")}
      >
        ES
      </LangButton>
      <LangButton
        type="button"
        $active={i18n.language?.startsWith("ca")}
        onClick={() => changeLanguage("ca")}
      >
        CA
      </LangButton>
    </Wrapper>
  );
};

export default LanguageSwitcher;
